// extracted by mini-css-extract-plugin
module.exports = {"extendedDropdown":"typeahead-new_extendedDropdown__b7e9D"};